import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../lib/metaPixel';
import { CreditCard, Landmark, ShieldCheck } from 'lucide-react';
export const Offer = () => {
  return <section id="oferta" className="py-14 bg-legal-900 relative" data-id="element-186" data-mp="1mo22e5uxyvgv">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-legal-800 via-legal-900 to-legal-900 pointer-events-none" data-id="element-187" data-mp="1mplmk7jpxqnx"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-188" data-mp="tzd8orw7tsf5">
        <div className="text-center mb-12" data-id="element-189" data-mp="p0a1p1wodc4j">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-190" data-mp="p1l7f79oktya">
            MEGAPACK ABOGADO 360° PRO™
          </h2>
          <p className="text-xl text-gold-500 font-medium" data-id="element-191" data-mp="yy7r3sq9teyq">
            10 Modulos + 5 Bonos Premium
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-lg mx-auto bg-legal-800 rounded-2xl border-2 border-gold-500 shadow-[0_0_40px_rgba(201,162,74,0.15)] overflow-hidden" data-id="element-192" data-mp="2fb4ykrc5au3y">
          <div className="bg-gold-500 py-4 text-center" data-id="element-193" data-mp="zi53s83jag1j">
            <span className="text-legal-900 font-bold uppercase tracking-wider text-sm" data-id="element-194" data-mp="zgk98ih7yx3o">
              Oferta Especial
            </span>
          </div>

          <div className="p-8 md:p-10" data-id="element-195" data-mp="6v0tbnlo99id">
            <div className="mb-6" data-id="element-196" data-mp="6rwgk1u555g3">
              <h3 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-197" data-mp="bsanthnx4bd2">
                Acceso inmediato y de por vida
              </h3>
              <p className="text-slate-400" data-id="element-198" data-mp="ft4e2hou2294">
                Material digital descargable + 5 bonos
              </p>
            </div>

            <div className="mb-8 pb-8 border-b border-legal-700" data-id="element-199" data-mp="3k8vsim9ioiad">
              <div className="flex items-end gap-3" data-id="element-200" data-mp="3k8dqf906b9uj">
                <span className="font-serif text-5xl font-bold text-white leading-none" data-id="element-201" data-mp="3o9fq1qy05nx1">
                  $27.990
                </span>
                <span className="text-slate-400 mb-1" data-id="element-202" data-mp="vdwbcljx7gn2">pago único</span>
              </div>
              <p className="text-sm text-gold-500 mt-2 font-medium" data-id="element-203" data-mp="qg4jfrj9zuiv">
                Incluye todos los bonos sin costo adicional.
              </p>
            </div>

            <a href="https://megapack-abogado-360-pro.impultienda.ar/checkout" onClick={() => trackEvent('InitiateCheckout', {
            content_name: 'MEGAPACK ABOGADO 360° PRO',
            currency: 'ARS',
            value: 27990
          })} className="block w-full py-5 hover:bg-gold-400 text-legal-900 font-bold rounded-xl text-xl text-center transition-all hover:scale-[1.02] active:scale-[0.98] shadow-lg mb-6 bg-[#4AC955]" data-id="element-204" data-mp="1067a3l2xcwe1">
              QUIERO MI MEGAPACK AHORA
            </a>

            <div className="space-y-4" data-id="element-205" data-mp="hi2dcxkoqboq">
              <p className="text-center text-sm text-slate-400 font-medium" data-id="element-206" data-mp="1ww6rm511z58r">
                Métodos de pago aceptados:
              </p>
              <div className="flex justify-center gap-6 text-slate-300" data-id="element-207" data-mp="1sul840u0jspl">
                <div className="flex flex-col items-center gap-1" data-id="element-208" data-mp="20dm5e4e80q4i">
                  <CreditCard className="w-6 h-6" data-id="element-209" data-mp="25dqkbpzhdcsm" />
                  <span className="text-xs" data-id="element-210" data-mp="25fbjjswqpjwt">Tarjetas</span>
                </div>
                <div className="flex flex-col items-center gap-1" data-id="element-211" data-mp="1qhj5z6ar75l9">
                  <div className="w-6 h-6 flex items-center justify-center font-bold text-lg leading-none" data-id="element-212" data-mp="1vfaurrg3qbl8">
                    mp
                  </div>
                  <span className="text-xs" data-id="element-213" data-mp="2j5n9bl5ur6ks">Mercado Pago</span>
                </div>
                <div className="flex flex-col items-center gap-1" data-id="element-214" data-mp="2o2wz51x5lk95">
                  <Landmark className="w-6 h-6" data-id="element-215" data-mp="29fvecptucbfs" />
                  <span className="text-xs" data-id="element-216" data-mp="29f24vh3hz7ty">Transferencia</span>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-legal-700 flex items-center justify-center gap-2 text-sm text-slate-400" data-id="element-217" data-mp="2ec2bpu868em4">
              <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-218" data-mp="36v9cskt9c7yl" />
              <span data-id="element-219" data-mp="36wkducvbj1m0">Pago 100% seguro. Garantía de 7 días.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};